export const ALERT_STATUS = ['open', 'archived'] as const
export const ALERT_READ_STATUS = ['read', 'unread'] as const

export const MONITOR_NEW_PATH = '/monitors/new'

export const NATURAL_LANGUAGE_STEP_PATH = '/steps/natural-language'
export const KEYWORDS_STEP_PATH = '/steps/keyword'
export const PATENT_LIST_STEP_PATH = '/steps/patent-list'
export const CORE_DETAILS_STEP_PATH = '/steps/core-details'
export const FILTERS_STEP_PATH = '/steps/filters'
export const ALERT_CONFIG_STEP_PATH = '/steps/alert-config'
export const PREVIEW_STEP_PATH = '/steps/preview'
export const OFFICE_ACTIONS_STEP_PATH = '/steps/office-actions'

export type MonitorStepPath =
  | typeof NATURAL_LANGUAGE_STEP_PATH
  | typeof PATENT_LIST_STEP_PATH
  | typeof KEYWORDS_STEP_PATH
  | typeof FILTERS_STEP_PATH
  | typeof CORE_DETAILS_STEP_PATH
  | typeof ALERT_CONFIG_STEP_PATH
  | typeof PREVIEW_STEP_PATH
  | typeof OFFICE_ACTIONS_STEP_PATH
